import lightGallery from 'lightgallery/lightgallery.umd';
import lgZoom from 'lightgallery/plugins/zoom';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
document.addEventListener('DOMContentLoaded', () => {

    lightGallery(document.querySelector('.c-image-gallery'), {
        plugins: [lgZoom, lgThumbnail],
        speed: 500,
        licenseKey: '27B98EF2-267A-4491-A872-77C77982E925',
    });

});
